<template>
  <div class="home">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide">
        <el-carousel
          class="banner-box"
          trigger="click"
          height="100%"
          arrow="never"
        >
          <el-carousel-item v-for="item in bannerList" :label="item.name" :key="item.id" :class="{'banner1-bg-mobile': item.name === '产品中心', 'banner2-bg-mobile': item.name === '技术优势', 'banner3-bg-mobile': item.name === '新品上线'}">
<!--            <img :src="'/boot'+item.picture" alt="">-->
            <div class="banner-bg" :style="{ background: `url(${'/boot'+item.picture})`, 'background-size': 'cover', 'zoom': setZooms() }">
              <div class="banner-con">
                <div v-html="item.createBy"></div>
<!--                <el-button class="btn-next">了解更多</el-button>-->
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <el-container class="body-zoom" style="height: 100%">
          <el-header class="slide-two-title-box">
            <div class="slide-two-title">
              产品中心
              <div></div>
            </div>
          </el-header>
          <el-main>
            <div class="slide-two-main-box">
              <el-tabs style="width: 100%;" v-model="productTabs" @tab-click="deviceTypeChange">
                <el-tab-pane :label="item.name" v-for="item in productTypeList" :key="item.id" :name="item.id">
                  <div class="slide-two-main">
                    <swiper id="swiperBox1" v-bind:options="swiperOption1" ref="mySwiper1" v-if="productList.length>isMobileCount">
                      <swiper-slide class="swiper-slide"  v-for="(item,i) in productList" :key="i">
                          <div class="products-box" @mouseenter="showMouseenter = item.id" @mouseleave="showMouseenter = null" @click="tiaozhuan(item)">
                            <div class="products-box-div" v-if="showMouseenter == item.id">
                              <div class="products-box-top">
                              </div>
                              <div class="products-box-con">
                                <h1>{{item.name}}</h1>
                                <span>{{item.description}}</span>
                              </div>
                              <div class="products-box-btm">
                                <span>查看详情</span>
                                <img src="@/assets/img/next-icon-fff.png" alt="">
                              </div>
                            </div>
                            <div class="products-box-top">
                              <img :src="'/boot'+item.url" :style="showMouseenter == item.id ? 'width:90%':''" alt="">
                            </div>
                            <div class="products-box-con">
                              <h1>{{item.name}}</h1>
                              <span>{{item.description}}</span>
                            </div>
                            <div class="products-box-btm">
                              <span>查看详情</span>
                              <img src="@/assets/img/next-icon.png" alt="">
                            </div>
                          </div>
                      </swiper-slide>
                    </swiper>
                    <div v-else>
                      <div class="products-box" style="display: inline-block"  @click="tiaozhuan(item)" v-for="(item,i) in productList" :key="i" @mouseenter="showMouseenter = item.id" @mouseleave="showMouseenter = null">
                        <div class="products-box-div" v-if="showMouseenter == item.id">
                          <div class="products-box-top">
                          </div>
                          <div class="products-box-con">
                            <h1>{{item.name}}</h1>
                            <span>{{item.description}}</span>
                          </div>
                          <div class="products-box-btm">
                            <span>查看详情</span>
                            <img src="@/assets/img/next-icon-fff.png" alt="">
                          </div>
                        </div>
                        <div class="products-box-top">
                          <img :src="'/boot'+item.url" :style="showMouseenter == item.id ? 'width:90%':''" alt="">
                        </div>
                        <div class="products-box-con">
                          <h1>{{item.name}}</h1>
                          <span>{{item.description}}</span>
                        </div>
                        <div class="products-box-btm">
                          <span>查看详情</span>
                          <img src="@/assets/img/next-icon.png" alt="">
                        </div>
                      </div>
                    </div>
                    <!-- 如果需要导航按钮 -->
                    <div class="swiper-button-prev" v-if="productList.length>isMobileCount"></div>
                    <div class="swiper-button-next" v-if="productList.length>isMobileCount"></div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-main>
        </el-container>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="slide-three">
          <div class="img-box">
            <div class="content-box">
              <h1>探索博为</h1>
              <div class="heng"></div>
              <span>河南博为智能科技有限公司自2016年成立以来一直致力于物联网信息产品研究，先后研发出变电站远程智能巡视、辅助监控、通信机房运行设备自动告警、中心机房电源检测等物联网产品。为传统电网到智能电网的升级发展增添新的动力。</span>
              <el-button class="next-btn" @click="openCompanyInfo">了解更多</el-button>
            </div>
          </div>
          <div class="img-box">
            <img src="../assets/img/home-img1.png" alt="">
          </div>
          <div class="img-box">
            <img src="../assets/img/home-img2.png" alt="">
          </div>
          <div class="img-box">
            <div class="content-box" style="margin-left: 12%;">
              <h1>为了更好的服务</h1>
              <div class="heng"></div>
              <span>为更好地服务社会大众，公司近几年加大对物联网信息产品研发投入，引进先进实验设备，建设现代化厂房，凭借物联网智能设备新锐技术，面向市场已推出串口联网设备、边缘计算网关、远程I/O模块、传感器等四大系列产品。目前产品已取得多项检测认证，应用于智慧电力、工业、交通、农业、建筑等行业。</span>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="slide-four">
          <el-container class="body-zoom">
            <el-header class="slide-two-title-box">
              <div class="slide-two-title">
                合作伙伴
                <div></div>
              </div>
            </el-header>
            <el-main class="main-box">
              <div class="logo-con">
                <div class="logo-box" v-for="(item,i) in logoList" :key="i">
                  <img :src="'/boot'+item.picture" alt="">
                </div>
              </div>
            </el-main>
          </el-container>
          <div class="footer body-zoom">
            <div class="footer">
              <div class="footer-content">
                <div class="content-left">
                  <div class="content-left-top">
                    <div>
                      <img :src="'/boot'+info.qrCodeWechat" alt="">
                      <p>微信公众号</p>
                    </div>
                    <div>
                      <img :src="'/boot'+info.qrCodeTm" alt="">
                      <p>天猫旗舰店</p>
                    </div>
                    <div>
                      <img :src="'/boot'+info.qrCodeJd" alt="">
                      <p>博为智能抖音</p>
                    </div>
                  </div>
                  <div class="content-left-bottom">
                    <p>联系方式：<a :href="`tel:${info.fixed}`">{{info.fixed}}</a>丨 <a :href="`tel:${info.phoneNumber}`">{{info.phoneNumber}}</a></p>
                    <p>电子邮箱：<a :href="`mailto:${info.email}`">{{info.email}}</a></p>
                    <p>公司地址：{{info.companyAddress}}</p>
                    <p>友情链接：<a href="http://www.hnbwzn.com/" target="_blank">河南博为智能科技有限公司</a> &nbsp;&nbsp; <a href="http://www.hnxintu.com/" target="_blank">SMT贴片加工</a></p>
                  </div>
                </div>
                <ul class="content-nav">
                  <li>
                    <p @click="$router.push({ path: '/product' })">产品中心</p>
                    <span v-for="item in productTypeList" @click="handleSelectMenu('/product',item)" :key="item.id">{{item.name}}</span>
                  </li>
                  <!--              <li>-->
                  <!--                <p>解决方案</p>-->
                  <!--                <span @click="handleSelectMenu('/industry')">智慧工业</span>-->
                  <!--                <span @click="handleSelectMenu('/energy')">智慧能源</span>-->
                  <!--                <span @click="handleSelectMenu('/power')">智慧电力</span>-->
                  <!--                <span @click="handleSelectMenu('/city')">智慧城市</span>-->
                  <!--                <span @click="handleSelectMenu('/building')">智慧建筑</span>-->
                  <!--              </li>-->
                  <li>
                    <p @click="$router.push({ path: '/about' })">关于我们</p>
                    <span @click="$router.push({ path: '/about#synopsis' })">博为简介</span>
                    <span @click="$router.push({ path: '/about#culture' })">企业文化</span>
                    <span @click="$router.push({ path: '/about#organization' })">组织架构</span>
                    <span @click="$router.push({ path: '/about#honor' })">资质荣誉</span>
                    <span @click="$router.push({ path: '/about#contact' })">联系我们</span>
                  </li>
                </ul>
              </div>
              <div class="copyright">
                <span>Copyright© 2025 河南博为智能科技有限公司 版权所有  <a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备2020029776号-2</a></span>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
<!--      <div slot="pagination" class="swiper-pagination"></div>-->

    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { configList, imgList, productsList, productsListTree } from "@/utils/http";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      showMouseenter: null,
      caseList: [],
      bannerList: [],
      productList: [],
      productTypeList: [],
      productTabs: undefined,
      info:{},
      logoList: [],
      bannerVal:'1',
      newsList: [],
      swiperOption2:{       //轮播插件配置参数
        pagination:{         //分页器
          el:'.swiper-pagination',
          clickable:true
        },
        loop:true,     //循环
        autoplay:{      //自动播放
          delay:1500,
          disableOnInteraction:false
        },
        speed:1500     //播放速度
      },
      swiperOption1:{
        loop:false,
        slidesPerView: 4, // 同时展示五个轮播项
        slidesPerGroup:4,
        spaceBetween: 8,
        centeredSlidesBounds:true,
        loopFillGroupWithBlank: false,
        initialSlide: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: false, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 48, // 高度设置，占满设备高度 navigator.userAgent.toLowerCase().includes(`qqbrowser`) ? `calc(100vh - 48px - 95px)` : `calc(100vh - 48px)`
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        }
      },
      isMobileCount: 4,
      windowHeight: window.innerHeight,
    };
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    // 屏幕分辨率缩放显示适配 - 设置模块缩放
    const t = window.devicePixelRatio   // 获取下载的缩放 125% -> 1.25    150% -> 1.5
    // var heigth_screen = window.screen.height;    // 获取整个屏幕的分辨率
    const width_screen = window.screen.width;
    let zoom = 1
    if(t !== 1) {
      zoom = (1 / t) * zoom;   // 就去修改页面的缩放比例
    }
    if(width_screen < 1366) {
      zoom = (width_screen / 1366) * zoom;   // 就去修改页面的缩放比例
    }
    // document.body.style.zoom = zoom;   // 就去修改页面的缩放比例
    let domsz = document.getElementsByClassName('body-zoom')
    for(let i = 0; i < domsz.length; i++) {
      domsz[i].style.zoom = zoom
    }

    // 首页产品模块滑块显示数量限制
    if(width_screen < 960) {
      this.isMobileCount = 1
      this.swiperOption1.slidesPerView = 1
      this.swiperOption1.slidesPerGroup = 1
    } else {
      this.isMobileCount = 4
      this.swiperOption1.slidesPerView = 4
      this.swiperOption1.slidesPerGroup = 4
    }

    this.getBannerList()
    this.getLogoList()
    this.getConfigList()
    this.getProductsListTree()
  },
  methods:{
    setZooms() {
      const t = window.devicePixelRatio   // 获取下载的缩放 125% -> 1.25    150% -> 1.5
      // var heigth_screen = window.screen.height;    // 获取整个屏幕的分辨率
      const width_screen = window.screen.width;
      let zoom = 1
      if(t !== 1) {
        zoom = (1 / t) * zoom;   // 就去修改页面的缩放比例
      }
      if(width_screen < 1366) {
        zoom = (width_screen / 1366) * zoom;   // 就去修改页面的缩放比例
      }
      return zoom
    },
    openCompanyInfo() {
      window.location.hash = "#/about#synopsis"
    },
    handleSelectMenu(path, {id, buyLink}){
      this.$router.push({path:path,query:{id, buyLink}})
    },
    tiaozhuan(item){
      // console.log('123123')
      this.$router.push({path:'/detail',query:{id:item.id, buyLink:item.buyLink}})
    },
    deviceTypeChange(val){
      this.getProductsList(Number(this.productTabs))
    },
    async getBannerList(){
      const res = await imgList(1);
      this.bannerList = res.rows
    },
    async getLogoList(){
      const res = await imgList(2);
      this.logoList = res.rows
    },
    async getProductsList(val){
      const res = await productsList(999,val);
      this.productList = res.rows
    },
    async getConfigList(){
      const res = await configList();
      this.info = res.rows[0]
    },
    async getProductsListTree() {
      const res = await productsListTree();
      this.productTabs = res.data[0].id
      this.productTypeList = res.data.map(item => {
        return {
          name: item.name,
          id: item.id
        }
      })
      this.getProductsList(this.productTabs)
    },
  }
};
</script>

<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */

.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  overflow: hidden;
  .banner-box{
    position: relative;
    height: 100%;

    ::v-deep .el-carousel__container {
      height: 100%;
    }
    .banner-bg{
      width: 100%;
      height: 100%;
      .banner-con{
        width: 100%;
        height: 100%;
        .btn-next{
          width: 88px;
          height: 30px;
          border-image: linear-gradient( 90deg, #11B2DE 0%, #135EE6 100%) 2 2;
          background: transparent;
          background: linear-gradient( 90deg, #11B2DE 0%, #135EE6 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          padding: 0;
        }
      }
    }
    //img{
    //  width: 100%;
    //  height: 100%;
    //  object-fit: cover;
    //  position: absolute;
    //  z-index: 1;
    //}

  }
  .slide-two-title-box{
    background: #fff;
    margin:60px 0;
    font-family: Microsoft YaHei, Microsoft YaHei;
    .slide-two-title{
      font-weight: bold;
      font-size: 26px;
      color: #222222;
      div{
        width: 24px;
        height: 4px;
        background: #0D2242;
        border-radius: 0px 0px 0px 0px;
        margin: 16px auto;
      }
    }
  }
  .slide-two-main-box{
    text-align: center;
    width: 100%;
    .slide-two-main{
      width: 1200px;
      margin: 60px auto;
      display: flex;
      .products-box{
        cursor: pointer;
        width: 225px;
        height: 488px;
        background: #FFFFFF;
        box-shadow: 0px 4px 16px 1px rgba(89,123,189,0.11);
        padding:0 30px;
        margin-left: 20px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        position: relative;
        .products-box-top{
          width: 100%;
          height: 52%;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            max-width: 225px;
            max-height: 160px;
          }
        }
        .products-box-con{
          width: 100%;
          height: 33%;
          text-align: left;
          h1{
            font-weight: bold;
            font-size: 16px;
            color: #222222;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            z-index: 1;
          }
          span{
            display:block;
            width: 100%;
            height: 60%;
            margin-top: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            -moz-box-orient:vertical;
          }
        }
        .products-box-btm{
          width: 100%;
          height: 15%;
          border-top: 1px solid #EAEAEA;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          color: #666666;
          cursor: pointer;
          img{
            width: 9px;
            height: 9px;
          }
        }
        img{
          width: 80%;
          object-fit: cover;

        }
      }
      .products-box:nth-child(1){
        margin-left: 0;
      }
      .products-box-div{
        width: 225px;
        height: 488px;
        background: linear-gradient( 359deg, #00399F 0%, rgba(95,134,203,0.35) 100%);
        border-radius: 0px 0px 6px 6px;
        position: absolute;
        padding:0 30px;
        left: 0;
        top: 0;
        .products-box-top{
          width: 100%;
          height: 52%;
        }
        .products-box-con{
          width: 100%;
          height: 33%;
          text-align: left;
          h1{
            font-weight: bold;
            font-size: 16px;
            color: #fff;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            z-index: 1;
          }
          span{
            display:block;
            width: 100%;
            height: 60%;
            margin-top: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #fff;
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            -moz-box-orient:vertical;
          }
        }
        .products-box-btm{
          width: 100%;
          height: 15%;
          border-top: 1px solid #EAEAEA;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
          img{
            width: 9px;
            height: 9px;
          }
        }
        img{
          width: 80%;
          object-fit: cover;

        }
      }
    }
  }
  .slide-three{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap:wrap ;
    align-content: space-between;
    .img-box{
      width: 49.9%;
      height: 49.8%;
      background: #000000;
      img{
        width: 100%;
        height: 100%;
      }
      .content-box{
        background: transparent;
        width: 430px;
        color: #FFFFFF;
        font-family: Microsoft YaHei, Microsoft YaHei;
        margin-left: 38%;
        h1{
          font-weight: bold;
          font-size: 26px;
          margin-top: 14%;
        }
        .heng{
          width: 24px;
          height: 4px;
          background: #FFFFFF;
          margin: 16px 0 27px 0;
        }
        span{
          font-size: 14px;
        }
        .next-btn{
          width: 88px;
          height: 30px;
          background: #FFFFFF;
          padding: 0;
          text-align: center;
          border-radius: 0px 0px 0px 0px;
          border: 1px solid #707070;
          display: block;
          margin-top: 65px;
        }
      }
    }
    //.img-box:hover{
    //  transform: scale(1.008)
    //}
    div:nth-child(1){
      background-image:url("../assets/img/home-bg1.png") ;
    }
    div:nth-child(4){
      background-image:url("../assets/img/home-bg2.png") ;
    }
  }
  .slide-four{
    position: relative;
    height: calc(100vh - 48px);
    .main-box{
      height: 280px;
      .logo-con{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        width: 1300px;
        margin: 0 auto;
        .logo-box{
          width: 285px;
          height: 116px;
          background: #FFFFFF;
          box-shadow: 0px 2px 16px 1px rgba(111,140,187,0.13);
          border-radius: 2px 2px 2px 2px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 10px;
        }
      }
    }
    .footer {
      width: 100%;
      height: 260px;
      overflow: hidden;
      background-color: #1E1E1E;
      position: absolute;
      bottom: 0;
      &-content {
        width: 1240px;
        height: 230px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .content-left{
          &-top{
            display: flex;
            div{
              text-align: center;
              margin-right: 45px;
              img{
                width: 100px;
                height: 100px;
                padding: 0;
              }
              p{
                margin: 0;
                font-size: 12px;
                color: #FFFFFF;
              }
            }
          }
          &-bottom{
            margin-top: 16px;
            font-size: 13px;
            color: #D4D4D4;
            line-height: 22px;

            a {
              color: #D4D4D4;
              text-decoration: none;
            }

            a:hover {
              color: #23527c;
              text-decoration: underline;
            }
          }
        }
        .content-nav {
          height: 170px;
          display: flex;
          justify-content: space-around;
          overflow: hidden;
          li {
            display: flex;
            flex-direction: column;
            padding: 0 20px;
            //justify-content: center;
            align-items: flex-start;
            font-family: Microsoft YaHei, Microsoft YaHei;
            p {
              font-size: 15px;
              color: #FFFFFF;
              padding: 10px 0;
            }
            span {
              font-size: 12px;
              color: rgba(255,255,255,0.6);
              font-weight: 300;
              padding: 5px 0;
            }
          }
        }
        img {
          width: 170px;
          height: 170px;
          padding: 10px;
        }
      }
      .copyright {
        height: 30px;
        background: #0E0E0E;
        text-align: center;
        span, a {
          color: #fff;
          line-height: 30px;
          font-size: 12px;
          text-decoration: none;
        }
        a:hover {
          color: #23527c;
          text-decoration: underline;
        }
      }

    }
  }
}

::v-deep .el-carousel__indicators{
  width: 1200px;
  margin: 0 auto;
}
::v-deep .el-carousel__button{
  width: 400px;
  height: 1px!important;
  background: #4C4C4C;
  position: relative;
  padding: 1px 18px;
  span{
    position: absolute;
    top: -30px;
    left: 0;
    color: #4C4C4C;
  }
}
::v-deep .el-carousel__indicator--horizontal{
  padding:10px 0;
}
::v-deep .el-carousel__indicator.is-active button{
  width: 400px;
  height: 1px!important;
  background:#137AF9;
  span{
    color: #137AF9;
  }
}
::v-deep .el-tabs__nav-scroll{
  width: 1200px;
  margin: 0 auto;
}
::v-deep .el-tabs__item{
  width: 240px;
  text-align: center;
  line-height: 20px;
  font-size: 16px;
}
.swiper-container {
  position: relative; /* 确保容器是相对定位 */
}

.swiper-button-prev, .swiper-button-next {
  position: absolute; /* 绝对定位 */
  top: 50%; /* 垂直居中 */
  transform: translateY(-50%); /* 微调位置 */
}

.swiper-button-prev {
  left: 290px; /* 少于四张图片时，左侧偏移 */
}

.swiper-button-next {
  right: 290px; /* 少于四张图片时，右侧偏移 */
}
</style>
